/** The move-vs-duplicate prompt for dropping a work code onto a level that
 *  already carries it. Renders nothing until such a drop is pending. */
import React from "react";
import DropConflictModal from "../../WbsBoardView/DropConflictModal/DropConflictModal";
import type { BarSpan } from "../../WbsBoardView/WbsBoardView";
import { hashColor } from "../helpers";

export interface DropConflict {
  leaf: { key: string; path: string[] };
  dayIndex: number;
  code: string;
  existingId: number;
}

interface Props {
  dropConflict: DropConflict | null;
  palette: Array<{ activityKey: string; name: string }>;
  effectiveCodeColors: Record<string, string>;
  protoCalendar: string[];
  protoSpanOf: (activityId: number) => BarSpan | null;
  handleProtoMove: (moves: Array<{ activityId: number; startIndex: number }>) => void;
  stageProtoDrop: (
    leaf: { key: string; path: string[] },
    dayIndex: number,
    code: string,
  ) => void;
  onClose: () => void;
}

const DropConflictFlow: React.FC<Props> = ({
  dropConflict,
  palette,
  effectiveCodeColors,
  protoCalendar,
  protoSpanOf,
  handleProtoMove,
  stageProtoDrop,
  onClose,
}) => {
  if (!dropConflict) return null;
  return (
    <DropConflictModal
      code={dropConflict.code}
      color={effectiveCodeColors[dropConflict.code] ?? hashColor(dropConflict.code)}
      codeName={
        palette.find((p) => p.activityKey === dropConflict.code)?.name ?? dropConflict.code
      }
      leafLabel={
        dropConflict.leaf.path[dropConflict.leaf.path.length - 1] ?? dropConflict.leaf.key
      }
      onMove={() => {
        const duration = protoSpanOf(dropConflict.existingId)?.durationDays ?? 1;
        handleProtoMove([
          {
            activityId: dropConflict.existingId,
            startIndex: Math.max(
              0,
              Math.min(dropConflict.dayIndex, protoCalendar.length - duration),
            ),
          },
        ]);
        onClose();
      }}
      onDuplicate={() => {
        stageProtoDrop(dropConflict.leaf, dropConflict.dayIndex, dropConflict.code);
        onClose();
      }}
      onClose={onClose}
    />
  );
};

export default DropConflictFlow;
